import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { faWaze, faGoogle, faUber } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-directions-select-dialog',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './directions-select-dialog.component.html',
  styleUrl: './directions-select-dialog.component.scss'
})
export class DirectionsSelectDialogComponent {

  faWaze = faWaze
  faGoogle = faGoogle
  faUber = faUber

  constructor(
    @Inject(MAT_DIALOG_DATA) public urls: any,
    private dialogRef: MatDialogRef<DirectionsSelectDialogComponent>
  ) {}

  closeModal() {
    this.dialogRef.close();
  }

  openMapWith(appName: 'waze'| 'google' | 'uber' = 'waze'){
    window.open(this.urls[appName], '_blank')
  }
}
